function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["children"],
  _excluded2 = ["children", "initialIsVisible", "overlay", "placement", "trigger"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { OverlayTrigger } from '../OverlayTrigger';
import { addSubcomponents } from '../_utils/addSubcomponents';
import { StyledContainer, StyledTooltip } from './Tooltip.styles';
var Content = /*#__PURE__*/React.forwardRef(function Content(_ref, ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledContainer, {
    ref: ref
  }, /*#__PURE__*/React.createElement(StyledTooltip, props, children));
});
var Tooltip_ = /*#__PURE__*/React.forwardRef(function Tooltip(_ref2, ref) {
  var children = _ref2.children,
    _ref2$initialIsVisibl = _ref2.initialIsVisible,
    initialIsVisible = _ref2$initialIsVisibl === void 0 ? false : _ref2$initialIsVisibl,
    overlay = _ref2.overlay,
    _ref2$placement = _ref2.placement,
    placement = _ref2$placement === void 0 ? 'top' : _ref2$placement,
    _ref2$trigger = _ref2.trigger,
    trigger = _ref2$trigger === void 0 ? 'hover' : _ref2$trigger,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var overlayNode = /*#__PURE__*/React.isValidElement(overlay) ? /*#__PURE__*/React.cloneElement(overlay, {
    placement: placement
  }) : /*#__PURE__*/React.createElement(Content, {
    placement: placement
  }, overlay);
  return /*#__PURE__*/React.createElement(OverlayTrigger, _objectSpread(_objectSpread({}, props), {}, {
    initialIsVisible: initialIsVisible,
    overlay: overlayNode,
    placement: placement,
    ref: ref,
    restoreFocusOnHide: false,
    trigger: trigger,
    shrinkOverlay: true,
    arrow: true
  }), children);
});
Tooltip_.displayName = 'Tooltip';
Content.displayName = 'Tooltip.Content';

/**

 We use tooltips to display additional descriptive information about an element
 or item to the user. For example, we could use them to explain a specific term
 or phrase, to denote the specific format required (e.g. mm/dd/yyy), or to
 clarify certain information (e.g. why a button is disabled).

 They can be displayed either by hovering over an element in the product or by
 hovering over an icon next to an element.

 @since 10.19.0

 @see [Storybook](https://stories.core.procore.com/?path=/story/core-react_demos-tooltip--demo)

 @see [Design Guidelines](https://design.procore.com/tooltip)

 */
export var Tooltip = addSubcomponents({
  Content: Content
}, Tooltip_);
//# sourceMappingURL=Tooltip.js.map